import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlowMaterialModule } from '@app/flow-material.module';

// Dialogs
import { ContentSelectDialog } from './content-select-dialog';

const dialogs = [ContentSelectDialog];

// Module Definition
@NgModule({
    declarations: dialogs,
    exports: dialogs,
    imports: [CommonModule, FlowMaterialModule, FormsModule, ReactiveFormsModule]
})

// Class Definition
export class ContentSelectDialogModule {}
